import { Plus } from 'lucide-react';
import { Button } from '../ui/Button';
import { useNavigate } from 'react-router-dom';

export default function SurveyHeader({ totalSurveys, onCreateSurvey, hideCreateButton = false }) {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-between mb-6">
      <div>
        <h1 className="font-display text-2xl font-bold text-foreground">Tous les sondages</h1>
        <p className="text-sm text-muted-foreground mt-1">Gestion globale des sondages de la plateforme</p>
      </div>
      {!hideCreateButton && (
        <Button onClick={() => navigate('/gerant/gestion-sondages/nouveau')} className="gap-2">
          <Plus className="h-4 w-4" />
          Nouveau sondage
        </Button>
      )}
    </div>
  );
}
